
<template>
  <!--添加物业公司-->
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
    <template slot="gps" slot-scope="{formItem}">
      <x-location
        :form="$children[0].form"
        :inputKey="inputKey"
        :position="position"
        :locationData="formItem">
      </x-location>
    </template>
  </x-addEdit>
</template>

<script>
import mixin from '../../../js/mixins';
import {REG, MESSAGE} from '../../../js/vlidator';
let decoratorOptions = {
  area_id: {
    rules: [{ required: true, message: '请选择所属城市' }]
  },
  property_full_name: {
    validateTrigger: 'blur',
    rules: [
      { required: true, message: '请输入公司名', whitespace: true },
      { min: 2, max: 50, message: '公司名为2-50个字' }
    ]
  },
  true_name: {
    validateTrigger: 'blur',
    rules: [
      { required: true, message: '请输入联系人', whitespace: true },
      { min: 2, max: 20, message: '联系人为2-20个字' }
    ]
  },
  mobile_phone: {
    validateTrigger: 'blur',
    rules: [
      { required: true, message: '请输入手机号码', whitespace: true },
      { pattern: REG.mobile, message: MESSAGE.mobile }
    ]
  },
  map_lng: {
    validateTrigger: 'blur',
    rules: [{ required: true, message: '请输入经度' }]
  },
  map_lat: {
    validateTrigger: 'blur',
    rules: [{ required: true, message: '请输入纬度' }]
  },
  property_address: {
    validateTrigger: 'blur',
    rules: [
      { required: true, message: '请输入公司地址', whitespace: true },
      { min: 2, max: 50, message: '公司地址为2-50个字' }
    ]
  },
  contract_number: {
    validateTrigger: 'blur',
    rules: [
      { whitespace: true, message: '不能输入空格' },
      { min: 2, max: 20, message: '合同编号为2-20个字' }
    ]
  },
  business_number: {
    validateTrigger: 'blur',
    rules: [{ whitespace: true }]
  },
  legal_name: {
    validateTrigger: 'blur',
    rules: [{ whitespace: true }]
  },
  business_address: {
    validateTrigger: 'blur',
    rules: [{ whitespace: true }]
  },
  business_img: {
    validateTrigger: 'blur'
  },
  legal_img: {
    validateTrigger: 'blur'
  }
};
export default {
  mixins: [mixin.fetchSelect],
  name: 'addCompany',
  data () {
    return {
      position: '',
      inputKey: {
        lng: 'map_lng',
        lat: 'map_lat',
        address: 'property_address'
      },
      formList: [
        {
          label: '所属城市',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择所属城市',
          handle: this.regionChange,
          props: ['area_id', decoratorOptions.area_id]
        },
        {
          label: '公司名',
          inputType: 'input',
          options: [],
          placeholder: '请输入公司名',
          props: ['property_full_name', decoratorOptions.property_full_name]
        },
        {
          label: '联系人',
          inputType: 'input',
          options: [],
          placeholder: '请输入联系人',
          props: ['true_name', decoratorOptions.true_name]
        },
        {
          label: '联系人手机号',
          inputType: 'input',
          options: [],
          placeholder: '请输入联系人手机号',
          props: ['mobile_phone', decoratorOptions.mobile_phone]
        },
        {
          slot: 'gps',
          label: 'GPS定位',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '经度',
              props: ['map_lng', decoratorOptions.map_lng]
            },
            {
              inputType: 'input',
              placeholder: '纬度',
              props: ['map_lat', decoratorOptions.map_lat]
            }
          ]
        },
        {
          label: '公司地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入公司营业执照注册地址',
          props: ['property_address', decoratorOptions.property_address]
        },
        {
          label: '合同编号',
          inputType: 'input',
          options: [],
          placeholder: '请输入合同编号',
          props: ['contract_number', decoratorOptions.contract_number]
        },
        {
          label: '营业执照号',
          inputType: 'input',
          options: [],
          placeholder: '请输入营业执照号',
          props: ['business_number', decoratorOptions.business_number]
        },
        {
          label: '法人代表',
          inputType: 'input',
          options: [],
          placeholder: '请输入法人代表',
          props: ['legal_name', decoratorOptions.legal_name]
        },
        {
          label: '注册地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入注册地址',
          props: ['business_address', decoratorOptions.business_address]
        },
        {
          label: '营业执照照片',
          inputType: 'upload',
          options: [],
          placeholder: '',
          name: 'business_img',
          resUrl: 'business_img',
          resName: 'file_name',
          fileList: [],
          uploadParam: {
            action: this.$store.state.uploadUrl,
            headers: {},
            accept: this.$store.state.imgAccept,
            listType: 'picture'
          },
          props: ['business_img', decoratorOptions.business_img]
        },
        {
          label: '法人持身份证照',
          inputType: 'upload',
          options: [],
          placeholder: '',
          name: 'legal_img',
          resUrl: 'legal_img',
          resName: 'file_name',
          fileList: [],
          uploadParam: {
            action: this.$store.state.uploadUrl,
            headers: {},
            accept: this.$store.state.imgAccept,
            listType: 'picture'
          },
          props: ['legal_img', decoratorOptions.legal_img]
        },
        {
          label: '合同期限',
          inputType: 'datePick',
          options: [],
          placeholder: '',
          props: ['contract_time', {
            rules: [{ required: false, message: '请选择合同期限' }]
          }]
        }
      ],
      formKey: {
        area_id: '',
        property_full_name: '',
        true_name: '',
        mobile_phone: '',
        map_lng: '',
        map_lat: '',
        property_address: '',
        contract_number: '',
        business_number: '',
        legal_name: '',
        business_address: '',
        business_img: '',
        legal_img: '',
        contract_time: ''
      },
      addParam: {
        url: '/property',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/property/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/property/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.setRequire();
    this.regionSelect(0, 'formList');
  },
  mounted () {
  },
  methods: {
    /* 设置合同有效期是否为必填 */
    setRequire () {
      this.formList.forEach((el) => {
        let props = el.props;
        if (props && props[0] === 'contract_time') {
          let rule = props[1].rules[0];
          this.$route.query.verify_status === '1' ? rule.required = true : rule.required = false;
        }
      });
    },
    regionChange (val, selected) {
      if (selected && selected.length) {
        let isCity = this.$store.state.citys.some(el => el === selected[0].label);
        if (isCity) { // 判断是否为直辖市
          this.position = selected[0].label;
        } else {
          this.position = selected[1].label;
        }
      }
    },
    detailResHandle (data) {
      if (data.province_name && data.city_name) {
        let isCity = this.$store.state.citys.some(el => el === data.province_name);
        if (isCity) { // 判断是否为直辖市
          this.position = data.province_name;
        } else {
          this.position = data.city_name;
        }
      }

      let formValues = {};
      formValues.legal_img = '';
      formValues.business_img = '';
      return formValues;
    },
    reqHandle (param) {
      if (param.contract_time) {
        param.contract_time = param.contract_time.format('YYYY-MM-DD');
      }
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/property/company/addCompany.vue